export const isSubscriptionOption = (option) => {
  return option.id === 'servicePackage';
};
